var map = {
	"./2018-03-04/whats-new.html": 2312,
	"./2018-04-12/whats-new.html": 2313,
	"./2018-04-24/whats-new.html": 2314,
	"./2018-05-23/whats-new.html": 2315,
	"./2018-05-31/whats-new.html": 2316,
	"./2018-07-04/whats-new.html": 2317,
	"./2018-07-19/whats-new.html": 2318,
	"./2018-11-20/whats-new.html": 2319,
	"./2019-04-04/whats-new.html": 2320,
	"./2020-01-21/whats-new.html": 2321,
	"./2020-07-18/whats-new.html": 2322,
	"./2021-06-10/whats-new.html": 2323,
	"./2021-07-26/whats-new.html": 2324,
	"./2021-08-26/whats-new.html": 2325,
	"./2021-12-07/whats-new.html": 2326,
	"./2022-06-03/whats-new.html": 2327,
	"./2022-09-08/whats-new.html": 2328,
	"./2023-01-01/whats-new.html": 2329,
	"./2023-06-14/whats-new.html": 2330,
	"./2024-10-31/whats-new.html": 2331,
	"./2024-12-12/whats-new.html": 2332,
	"./2026-02-04/whats-new.html": 2333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2311;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2311
// module chunks = 0